import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
export const removeAgentRecruitmentTags = createAsyncThunk(
  "agent-recruitment/removeAgentRecruitmentTags",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.put(
        `${process.env.REACT_APP_BASE_URL}api/recruitment/${data.id}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return resp.data.agentRecruitment;
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response.data.message);
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
